import React, { useState, useContext } from 'react';
import AuthService from '../../services/AuthService';
import AuthContext from '../../contexts/AuthContext';
import ButtonMinimal from '../buttons/ButtonMinimal';
import './PathCard.css'

const PathCard = ({ pathId, pathName, followers, estimatedTime, description, tags }) => {

    const { user } = useContext(AuthContext);

    const [isFollowed, setIsFollowed] = useState(true);

    const toggleFollow = async (e) => {
        e.preventDefault();
        const endpoint = `/api/userdata/${isFollowed ? 'unfollowPath' : 'followPath'}`;
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ pathId: pathId })
        });

        if (response.ok) {
            setIsFollowed(!isFollowed);
            if (isFollowed) {
                // Remove the object with the matching pathId from followedPath
                user.followedPath = user.followedPath.filter(path => Number(path.pathId) !== Number(pathId));
            } else {
                // Add a new object with pathId to followedPath
                user.followedPath = [...user.followedPath, { pathId, createdAt: new Date() }];
            }
            AuthService.syncLocalUserSession(user);
        } else {
            console.error('Failed to update followed path.');
        }
    };

    return (
        <div className="path-card card">
            <div className="card-header">
                <div className="flex-container">
                    <span className="path-name card-title">{pathName}</span>
                    <ButtonMinimal value={isFollowed ? (<><span>Unfollow</span></>) : (<><span className="plus-sign">+ </span><span>Follow</span></>)} className={`follow-button ${isFollowed ? 'unfollow-button' : 'follow-button'}`} onClick={toggleFollow} />
                </div>
                <div className="meta-data">
                    <span className="followers">{followers}
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-user-plus" width="18" height="18" viewBox="0 0 24 24" stroke-width="1" stroke="#6c757d" fill="none" stroke-linecap="round" stroke-linejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <circle cx="9" cy="7" r="4" />
                            <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                            <path d="M16 11h6m-3 -3v6" />
                        </svg>
                    </span>
                    {estimatedTime && (
                        <span className="estimated-time">{estimatedTime}
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-clock" width="18" height="18" viewBox="0 0 24 24" stroke-width="1" stroke="#6c757d" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <circle cx="12" cy="12" r="9" />
                                <polyline points="12 7 12 12 15 15" />
                            </svg>
                        </span>
                    
                    )}
                </div>
            </div>
            
            <div className="card-body">
                <p className="description font-4">{description}</p>
                {tags && (
                    <div>
                        {tags.map((tag, index) => (
                            <span key={index} className="tag">{tag}</span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PathCard;
